/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
// libraries
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from "react-icons/fa";
// utils
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import Popular from '../populares/Popular';
import styles from './About2.module.css';

const AboutPieces2: React.FC<{
    site: any;
    allRodape: any;
    hidePopular?: boolean;
}> = ({ site, allRodape, hidePopular }) => {
    const showLoftBadge = Number(site?.id) === 1898;

    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: <FaInstagram/>,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: <FaFacebook/>,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: <FaTwitter/>,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: <FaTiktok/>,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: <FaYoutube/>,
            rede: 'Youtube'
        },
    ];

    return (
        <>
            {site?.modelo_pesquisa_popular == 1 && !hidePopular && Number(site?.id) !== 2551 && <Popular site={site} allRodape={allRodape}/>}
            <footer className={styles.footer}>
                <div className={styles.footerContainer}>
                    {/* Logo Section */}
                    {site?.url_logo &&
                    <div className={`${styles.footerLogoLinkContainer} ${showLoftBadge ? styles.footerLogoBadgeContainer : ''}`}>
                        <Link prefetch={false} href="/" className={styles.footerLogoLink}>
                            <div className={styles.footerLogoContainer}>
                                <Image
                                    alt="Logo da Imobiliária"
                                    src={`${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                    fill
                                    style={{ objectFit: 'contain' }}
                                />
                            </div>
                        </Link>
                        {showLoftBadge ? (
                            <div
                                id="loft-badge"
                                data-agency-id="35202722000103"
                                style={{ width: 100, height: 100 }}
                            />
                        ) : null}
                    </div>}

                    {/* Content Container */}
                    <div className={styles.footerContentContainer}>
                        <div className={styles.footerInfoContainer}>
                            {/* Address Column */}
                            <div className={styles.footerInfoColumn}>
                                <p className={styles.footerInfoText}>
                                    {site?.Dados?.endereco.toUpperCase()}
                                </p>
                                 {site?.Dados?.creci ?
                                    <p className={styles.footerInfoText}>
                                        {`${site?.Dados?.creci}`}
                                    </p>
                                : null}
                                {site?.id == 2379 ?
                                    <p className={styles.footerInfoText}>
                                        CNPJ: 62.335.787/0001-08
                                    </p>
                                : null}
                                {site?.id == 2168 ?
                                    <p className={styles.footerInfoText}>
                                        CNPJ: 56.171.086/0001-70
                                    </p>
                                : null}
                                {site?.html_rodape ?
                                    <p className={styles.footerInfoText}
                                        dangerouslySetInnerHTML={{
                                            __html: site?.html_rodape,
                                        }}>
                                    </p>
                                : null}
                                <ul className={styles.footerInfoList}>
                                    <li className={styles.footerInfoListItem}>
                                        <a
                                            className={styles.footerLink}
                                            target="_blank"
                                            href={site?.url_maps ? site?.url_maps : `https://www.google.com/maps/dir//${(site?.Dados?.endereco ? site?.Dados?.endereco+"-" : '')+(site?.Dados?.bairro+"-"+site?.Dados?.cidade)}`}
                                            rel="noopener noreferrer"
                                        >
                                            {`> COMO CHEGAR`}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* Hours Column */}

                            <div className={styles.footerInfoColumn}>
                                {site?.Dados?.horario ?
                                    <p className={styles.footerInfoText}>
                                        {`Horário de Atendimento: ${
                                            site?.Dados?.horario
                                        }`}
                                </p> : null}
                                {site?.id != 2456 ?
                                    <ul className={styles.footerInfoList}>
                                        <li className={styles.footerInfoListItem}>
                                            <Link prefetch={false} href="/termos" className={styles.footerLink}>
                                                {`> TERMOS DE USO`}
                                            </Link>
                                        </li>
                                        <li className={styles.footerInfoListItem}>
                                            <Link prefetch={false} href="/politica" className={styles.footerLink}>
                                                {`> POLÍTICA DE PRIVACIDADE`}
                                            </Link>
                                        </li>
                                    </ul>: null}
                            </div>

                            {/* Contact Column */}
                            <div className={styles.footerInfoColumn}>
                                <p className={styles.footerInfoText}>{site?.id == 2456 ? "ATENDIMENTO  PERSONALIZADO" : "CENTRAL DE VENDAS"}</p>
                                {site?.Dados?.tel1 ?
                                <p className={`${styles.footerInfoText} ${styles.footerInfoTextPhone}`}>
                                    <a
                                        className={styles.footerLink}
                                        target="_blank"
                                        href={`tel:+55${site?.Dados?.tel1?.replace(/\D/g, '')}`}
                                        data-no-quicklink
                                rel="noopener noreferrer"
                                    >
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                            <g><path fill="none" d="M0 0h24v24H0z"></path><path d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"></path></g>
                                        </svg>
                                        {site?.Dados?.tel1}
                                    </a>
                                </p>: null}
                                {site?.Dados?.tel2 ?
                                <p className={`${styles.footerInfoText} ${styles.footerInfoTextPhone}`}>
                                    <a
                                        className={styles.footerLink}
                                        target="_blank"
                                        href={`tel:+55${site?.Dados?.tel2?.replace(/\D/g, '')}`}
                                        rel="noopener noreferrer">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                            <g><path fill="none" d="M0 0h24v24H0z"></path><path d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"></path></g>
                                        </svg>
                                        {site?.Dados?.tel2}
                                    </a>
                                </p>: null}
                                {site?.Dados?.tel3 ?
                                <p className={`${styles.footerInfoText} ${styles.footerInfoTextPhone}`}>
                                    <a
                                        className={styles.footerLink}
                                        target="_blank"
                                        href={`tel:+55${site?.Dados?.tel3?.replace(/\D/g, '')}`}
                                        rel="noopener noreferrer">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                            <g><path fill="none" d="M0 0h24v24H0z"></path><path d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"></path></g>
                                        </svg>
                                        {site?.Dados?.tel3}
                                    </a>
                                </p>: null}

                            </div>
                        </div>

                        {/* Copyright */}
                        <div className={styles.footerCopyrightContainer}>
                            <p className={styles.footerCopyrightText}>
                                Todos os Direitos Reservados. As imagens deste site são de uso exclusivo da {site?.Dados?.Empresa || site?.Dados?.titulo || "imobiliária"}.
                            </p>
                        </div>
                    </div>

                    {/* External Links */}
                    <div className={styles.footerExternalLinksContainer}>
                        {/* Social Links */}
                        <div className={styles.footerSocialLinkContainer}>
                            {allSocials?.map((social) => {
                                if (social.href) {
                                    return (
                                        <a
                                            key={social.id}
                                            className={`${styles.footerLink} ${styles.footerSocialLink}`}
                                            target="_blank"
                                            href={social.href}
                                            rel="noopener noreferrer"
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                trackLead(site, null);
                                                setTimeout(() => {
                                                    window.open(social.href, "_blank");
                                                }, 300);
                                            }}
                                        >
                                            {social.icon}
                                        </a>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </div>
                </div>
            </footer>
            {showLoftBadge ? (
                <Script
                    id="loft-badge-script-1898"
                    defer
                    type="module"
                    src="https://loft-badge.loft.com.br/index.js"
                />
            ) : null}
        </>
    );
};

export default AboutPieces2;
